/** Keyboard shortcut labels matching the user's platform: ⌘ on Apple devices, Strg everywhere else */

function platformText(): string {
    if (typeof navigator === 'undefined') {
        return '';
    }
    const uaData = (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData;
    return uaData?.platform || navigator.platform || navigator.userAgent || '';
}

export function isApplePlatform(): boolean {
    return /Mac|iPhone|iPad|iPod|macOS/i.test(platformText());
}

/** "⌘" or "Strg" */
export function modKeyLabel(): string {
    return isApplePlatform() ? '⌘' : 'Strg';
}

/**
 * Label of a shortcut with the platform modifier, e.g. shortcutLabel('K') → "⌘K" / "Strg+K",
 * shortcutLabel('Enter') → "⌘ + Enter" / "Strg + Enter".
 */
export function shortcutLabel(key: string): string {
    if (isApplePlatform()) {
        return key.length === 1 ? `⌘${key}` : `⌘ + ${key}`;
    }
    return key.length === 1 ? `Strg+${key}` : `Strg + ${key}`;
}

/** Ctrl on Windows/Linux, Cmd on macOS – the modifier the shortcut labels refer to */
export function isModKey(event: KeyboardEvent | MouseEvent): boolean {
    return isApplePlatform() ? event.metaKey : event.ctrlKey;
}
